module.exports = __webpack_public_path__ + "static/media/icon-speaker-warning.f02b69e8.svg";